import { format, isSameDay } from "date-fns";
export { canStartTurnoverClean } from "@/lib/turnoverWindow";

/**
 * Parse a date-only string (yyyy-MM-dd) or date part of ISO string as local calendar date.
 * Avoids new Date(str) / parseISO(str) treating it as UTC midnight, which
 * shows the previous day in timezones behind UTC.
 */
export function parseLocalDateOnly(dateStr: string): Date {
  const dateOnly = dateStr.slice(0, 10);
  const parts = dateOnly.split("-").map(Number);
  if (parts.length !== 3 || parts.some((n) => Number.isNaN(n))) return new Date(dateStr);
  const [y, m, d] = parts;
  return new Date(y, m - 1, d);
}

/**
 * Normalize a Date to local midnight for the same calendar day.
 * Use when the date may be UTC midnight (e.g. from a calendar picker); in western TZ
 * that would otherwise display/save as the previous day. Returns local midnight for
 * the year/month/day of the date interpreted in UTC.
 */
export function toLocalCalendarDate(d: Date): Date {
  return new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
}

/**
 * Format a scheduled_date (yyyy-MM-dd) for display without timezone shift.
 * Use wherever task.scheduled_date is shown (Task Details, schedule, etc.).
 */
export function formatScheduledDate(dateStr: string, formatStr: string): string {
  return format(parseLocalDateOnly(dateStr), formatStr);
}

/** True when the task's scheduled calendar day (local) is today — not before or after. */
export function isCleaningScheduledForToday(scheduledDate: string): boolean {
  return isSameDay(parseLocalDateOnly(scheduledDate), new Date());
}
